module.exports = __webpack_public_path__ + "static/media/18.ee53dfb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/18.png
// module id = 1300
// module chunks = 0